import { NgModule } from '@angular/core';
import { SanitizeUrlPipe } from './bypass-sanitize-url.pipe';


@NgModule({
	imports: [],
	exports: [SanitizeUrlPipe,],
	declarations: [SanitizeUrlPipe,],
	providers: [],
})
export class SanitizeUrlPipeModule { }